@if (text) {
  <div class="flex flex-col items-center">
    <mat-chip
      class="badge-status-{{taskDetails.taskStatus?.toLowerCase()}}{{taskDetails.isPriority ? '-priority' : ''}} flat">
      @if (isPaused && taskDetails.pauseReasonCode && canBackOfficeUnPause) {
        <mat-icon matChipAvatar>warning</mat-icon>
      }

      <span [ngClass]="classes">
        {{ text | translate }}
      </span>
    </mat-chip>

    @if (isPaused && taskDetails.pauseReasonCode) {
      <span class="text-[var(--tertiary-10 text-sm font-medium leading-4 tracking-wide">
        {{ 'yardOperations.driver.pauseReasons.' + taskDetails.pauseReasonCode| translate }}
      </span>
    }
  </div>
}
